<template>
  <div>
    <div class="flex a-center j-center" style="height: 60px">
      <span class="bold fs-16">关联页面设置</span>
    </div>
    <div class="flex-column a-center j-center" style="width: 550px;">
      <Input class="m-t-20 m-b-10" clearable placeholder="链接地址" readonly style="width: 450px" v-model="editData.url">
        <span @click="showMaterialModal" slot="append"
              style="cursor:pointer">
            <i class="icon-link"/>
          </span>
      </Input>
    </div>

    <div class="flex a-center j-center" style="height: 60px">
      <Button @click="shareSettingCancel" class="m-r-10">取消</Button>
      <Button @click="shareSettingOk" class="m-l-10">确定</Button>
    </div>

    <material-choice-widget
      :hasMine="false"
      :on-ok="materialChoiceOk"
      :pages="choosePage()"
      ref="materialChoiceWidget"
      title="选择链接"/>
  </div>
</template>

<script>
import MaterialChoiceWidget from '@/components/common/chiose/MaterialChoiceWidget'
import {getPages} from '@/components/common/chiose/MaterailChoiceWidgetUtil'

export default {
  name: 'RelationPageUrl',
  components: {MaterialChoiceWidget},
  props: {
    editData: {
      type: Object,
      default: () => {
        return {
          hasdecorateMode: 1,
          url: ''
        }
      }
    }
  },
  data () {
    return {}
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    choosePage () {
      //引导页
      return getPages([1, 9])
    },
    materialChoiceOk (data) {
      if (data && data.length > 0) {
        this.editData.url = data[0].url
      }
    },
    showMaterialModal () {
      this.$refs.materialChoiceWidget.show()
    },
    shareSettingCancel () {
      this.$emit('cancel')
    },
    shareSettingOk () {
      this.$emit('config',this.editData)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
